import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
// import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'

import PrivateRoute from './../../../component/PrivateRoute'
import NotFound from './../../NotFound'

import { setPageTitle } from './../../../actions'

import TESubNavbar from './../../../component/Navigation/TESubNavbar'

import Live from './Live'
import History from './History'
import Job from './Job'
import Product from './Product'

// import styles from './styles'

class Jobs extends Component {
	componentDidMount() {
		const { setPageTitle } = this.props
		setPageTitle('Service Cases')
	}

	render() {
		return (
			<Fragment>
				<TESubNavbar
					links={[
						{
							title: 'Active',
							to: `/technician/jobs/live`,
						},
						{
							title: 'History',
							to: `/technician/jobs/history`,
						},
					]}
				/>
				<Switch>
					<PrivateRoute
						path="/technician/jobs/:status/:jobUID/:productUID"
						component={Product}
						requiredUserType="technician"
					/>
					*
					<PrivateRoute
						path="/technician/jobs/:status/:uid"
						component={Job}
						requiredUserType="technician"
					/>
					<PrivateRoute
						path="/technician/jobs/live"
						component={Live}
						requiredUserType="technician"
					/>
					<PrivateRoute
						path="/technician/jobs/history"
						component={History}
						requiredUserType="technician"
					/>
					<Route component={NotFound} />
				</Switch>
			</Fragment>
		)
	}
}

Jobs.propTypes = {}

Jobs.defaultProps = {}

const mapStateToProps = (state) => {
	const { userModel } = state.Loading
	return { userModel }
}

export default connect(
	mapStateToProps,
	{ setPageTitle }
)(Jobs)
